import React from 'react';

import Helmet from 'common/helmets/Helmet';

const Title = 'Akiflow Case Study | Canny';
const Description =
  'How Akiflow organized their feedback and started winning back churned customers';
const Image = 'https://canny.io/images/5a122a7ae6cf1719a5fd5b4d7cee1230.jpg';

const AkiflowLandingHelmet = () => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: 'https://canny.io/case-studies/akiflow' },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}
    />
  );
};

export default AkiflowLandingHelmet;
